import React,{ FC, useEffect, useState } from "react";
import styles from "./index.module.less";
import { useDocumentTitle } from "~src/hooks/useDocumentTitle";
import { getInvoiceDetail } from "~src/service/bill";
import useQuery from "~src/hooks/useQuery";
import { Empty ,Image, ImageViewer} from "antd-mobile";
import { InvoicePreviewType } from "~src/service/bill/bill";



const BillRelated: FC = () => {
  useDocumentTitle('发票预览')
  const searchQuery = useQuery()
  const id = searchQuery("id")
  const biz = searchQuery("biz")
  const [visible, setVisible] = useState(false)
  const [invoice, setInvoice] = useState<InvoicePreviewType[]>([])
  const [index, setIndex] = useState<number>(0)

  const pullDetails = async () => {
    const {invoices} = await getInvoiceDetail({bizName: biz, outInvoiceId: id as string})
    setInvoice(invoices)
  }

  useEffect(() => {
    pullDetails()
  }, [])

  return <div className={styles.preview}>
    {invoice.length > 0? <>
      {
        invoice.map((item,index) =>  <Image onClick={() => {setIndex(index)}} style={{marginTop: 30}} src={item.eInvoiceMiniUrl}></Image>)
      }
    <div className={styles.tips}>*长按可保存图片</div>
    </>:<Empty description='暂无数据' />
    }
    <ImageViewer.Multi
      images={invoice.map(ele => ele.eInvoiceMiniUrl)}
      visible={visible}
      defaultIndex={index}
      onClose={() => {
        setVisible(false)
      }}
    />
  </div>
}
export default BillRelated